import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "./DashboardLayout";
import DashboardStats from "./Dashboard/DashboardStats";
import TransactionsManagement from "./Dashboard/Transactions";
import baseURL from "../config";
import PageLoader from "../../../Reusable/PageLoader"; // Loader component

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchDashboardData() {
      try {
        const [statsRes, transactionsRes] = await Promise.all([
          fetch(`${baseURL}/admin/dashboard/stats`, { credentials: "include" }),
          fetch(`${baseURL}/admin/admin-transactions`, { credentials: "include" }),
        ]);

        if (statsRes.status === 403 || transactionsRes.status === 403) {
          navigate("/admin/login", { replace: true });
          return;
        }

        if (!statsRes.ok || !transactionsRes.ok) {
          throw new Error("Failed to load dashboard data");
        }

        setStats(await statsRes.json());
        setTransactions(await transactionsRes.json());
      } catch (err) {
        console.error(err);
        toast.error(err.message || "Something went wrong while loading dashboard.");
      } finally {
        setLoading(false);
      }
    }

    fetchDashboardData();
  }, [navigate]);

  return (
    <DashboardLayout>
      {loading ? (
        // Loader only inside the layout content area
        <PageLoader
          message="Loading Dashboard..."
          subtext="Fetching stats and transactions"
        />
      ) : (
        <>
          <DashboardStats stats={stats} />
          <TransactionsManagement transactions={transactions} />
        </>
      )}
    </DashboardLayout>
  );
};

export default Dashboard;
